import {setupBasicSuggestSelect} from '../../../common/suggests';

$(() => {
    // 請求元口座情報
    if (document.getElementById('agent-biller-setting') != null) {
        setupBasicSuggestSelect('.js-bank-name', '/agent/findBank', '銀行名を入力', null, null, null);
		$('.js-bank-name').on('change', function(e) {
            let selectedBank = $('.js-bank-name option:selected').val();
            if (isNaN(selectedBank)) {
                selectedBank = '';
            }
            $('.bank-code').text(selectedBank);
            $('.js-branch-name').val(null).trigger('change');
        });
        setupBasicSuggestSelect('.js-branch-name', '/agent/findBranch', '支店名を入力', branchParamaterFilter, null, null);
		$('.js-branch-name').on('change', function(e) {
            let selectedBranch = $('.js-branch-name option:selected').val();
            if (isNaN(selectedBranch)) {
                selectedBranch = '';
            }
            $('.branch-code').text(selectedBranch);
        });
    }

});

// 支店名用パラメータフィルター
function branchParamaterFilter(params) {
    let selectedBank = $('.js-bank-name option:selected').val();
	var query = {
		search: params.term,
		code: selectedBank,
	}
	return query;
}
